export default __webpack_public_path__ + "static/media/pag12.f8486188.jpg";